/* js/components/ParcoursPath.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal
} from "svelte/internal";

import { onMount, onDestroy } from 'svelte';
import { getContext, createEventDispatcher } from 'svelte';
import { key } from '../maplibre.js';

function create_fragment(ctx) {
	let div;

	return {
		c() {
			div = element("div");
		},
		m(target, anchor) {
			insert(target, div, anchor);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

function makeSourceFromGeom(geom) {
	const source = {
		'type': 'geojson',
		'data': geom,
		'generateId': true
	};

	return source;
}

function instance($$self, $$props, $$invalidate) {
	let { parcoursSlug } = $$props;
	let { pathData } = $$props;
	let { pathColor = '#eee' } = $$props;
	let { lineWidth = 8 } = $$props;
	const { getMap } = getContext(key);
	const map = getMap();
	const sourceId = parcoursSlug;
	const linesLayerId = `${sourceId}_layer_lines`;
	const pointsLayerId = `${sourceId}_layer_points`;

	onMount(async () => {
		const source = makeSourceFromGeom(pathData);

		// console.log("source", source);
		map.addSource(sourceId, source);

		map.addLayer({
			'id': linesLayerId,
			'type': 'line',
			'source': sourceId,
			'layout': {
				'line-join': 'round',
				'line-cap': 'round'
			},
			'paint': {
				'line-color': pathColor,
				'line-width': lineWidth
			},
			'filter': ['==', '$type', 'LineString']
		});

		map.addLayer({
			'id': pointsLayerId,
			'type': 'circle',
			'source': sourceId,
			'paint': {
				'circle-radius': 6,
				'circle-color': '#B42222'
			},
			'filter': ['==', '$type', 'Point']
		});
	});

	onDestroy(() => {
		console.log("destroy---------------------------------------");

		try {
			if (map.getLayer()) {
				map.removeLayer(linesLayerId);
				map.removeLayer(pointsLayerId);
				console.log("removed path with id ", linesLayerId);
				console.log("removed path with id ", pointsLayerId);
			}
		} catch(e) {
			
		} // do nothing
	});

	$$self.$$set = $$props => {
		if ('parcoursSlug' in $$props) $$invalidate(0, parcoursSlug = $$props.parcoursSlug);
		if ('pathData' in $$props) $$invalidate(1, pathData = $$props.pathData);
		if ('pathColor' in $$props) $$invalidate(2, pathColor = $$props.pathColor);
		if ('lineWidth' in $$props) $$invalidate(3, lineWidth = $$props.lineWidth);
	};

	return [parcoursSlug, pathData, pathColor, lineWidth];
}

class ParcoursPath extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			parcoursSlug: 0,
			pathData: 1,
			pathColor: 2,
			lineWidth: 3
		});
	}
}

export default ParcoursPath;